export default __webpack_public_path__ + "static/media/register-bg.5e0648fd.svg";